<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <b-form-group :label="$t('type')">
                        <ValidationProvider name="type" rules="required" v-slot="{ errors }">
                            <ParameterSelectbox code="infirmary_user_types" v-model="formData.type" :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="control_building"
                                        rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('campus')">
                            <campus-selectbox v-model="formData.control_building"
                                              :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('date_between')">
                        <v-date-picker
                            v-model="date"
                            is-range>
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1">
                                        <b-form-group class="m-0 mr-1">
                                            <input :value="inputValue.start"
                                                   v-on="inputEvents.start"
                                                   :placeholder="$t('start_date')"
                                                   class="form-control"/>
                                        </b-form-group>
                                    </div>
                                    <div class="flex-grow-1">
                                        <b-form-group class="m-0 ml-1">
                                            <input :value="inputValue.end" v-on="inputEvents.end"
                                                   :placeholder="$t('end_date')"
                                                   class="form-control"/>
                                        </b-form-group>
                                    </div>
                                </div>
                            </template>
                        </v-date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <ProcessingButton variant="primary"
                          @click="activityReport"
                          :processing="formLoading"
                          :label="$t('download_report')"
                          :disabled="formLoading">
                </ProcessingButton>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import CampusSelectbox from "@/components/interactive-fields/CampusSelectbox.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import InfirmaryServices from "@/services/InfirmaryServices";
import qs from "qs";
import moment from "moment";

export default {
    name: "ActivityReport",
    components: {ProcessingButton, CampusSelectbox},
    data (){
        return {
            formData: {
                type:null,
            },
            date:null,
            formLoading: false,
        }
    },
    methods:{
        async activityReport(){
            const isValid =await this.$refs.formModalValidate.validate()
            if (!isValid) return
            this.formLoading=true
            try {
                if (this.date?.start && this.date?.end){
                    this.formData.medical_examination_date_greater_than=moment(this.date.start).format('YYYY-MM-DD')
                    this.formData.medical_examination_date_smaller_than=moment(this.date.end).format('YYYY-MM-DD')
                }
                const filter={
                    params:{
                        filter:{
                            ...this.formData
                        },
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
              const res =  await InfirmaryServices.activityReport(filter)
                this._downloadFile(res, this.$t("activity_report") + '.xlsx')
                this.$emit("successActivityReport")
            }catch (error) {
                this.showErrors(error,this.$refs.formModalValidate,true)
            }finally {
                this.formLoading=false
            }
        }
    }
}
</script>

<style scoped>

</style>
